define([
  'js/aofl-js/0.8.0/aofl-modules/__build/aofljs.min'
], function OnboardingVmModule(aoflModules) {
  'use strict';
  var storeService = aoflModules.store;

  var vmService = function vmService(
    $state,
    riqUserModelService,
    riqApiService
  ) {
    riqApiService.setApiEndpoints({submitSurvey: 'survey_submit_answer'});

    var selectProfile = function selectProfile(profile) {
      var profileUuid = profile.profileUuid;
      return riqUserModelService
        .loginAs(profileUuid)
        .then(function(payload) {
          storeService.commit([
            {
              stateAlias: 'profile',
              mutationId: 'setUserProfile',
              payload: payload
            }
          ]);
          return payload;
        })
        .catch(function(error) {
          // TODO: Add error handling
          console.error(error);

          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var goToNextStep = function goToNextStep() {
      storeService.commit([
        {
          stateAlias: 'user',
          mutationId: 'updateOnBoardingStep',
          payload: null
        }
      ]);
      const state = storeService.getState();
      if (!state.user.$onboardingStep) {
        // eslint-disable-next-line no-use-before-define
        completeUserOnboarding();
      }
    };

    var updateUserAccountDetails = function updateUserAccountDetails(
      userDetailsObj
    ) {
      var state = storeService.getState();
      var userUuid = state.user.userUuid;
      var data = {
        userUuid: userUuid,
        userDetails: userDetailsObj
      };
      return riqUserModelService
        .updateUserAccount(data)
        .then(function(response) {
          return response;
        })
        .catch(function(error) {
          // TODO: Add error handling
          console.error(error);

          storeService.commit([
            {
              stateAlias: 'riqToastrs',
              mutationId: 'show',
              payload: 'applicationError'
            }
          ]);
        });
    };

    var completeMarketingSurvey = function completeMarketingSurvey() {
      var state = storeService.getState();
      var mainSelection = state.marketingSurvey.mainSelection;
      var subSelection = state.marketingSurvey.subSelection;
      var subSelectionOther = state.marketingSurvey.subSelectionOther;
      subSelection = subSelectionOther ? subSelectionOther : subSelection;
      var concatMainSubSelections = mainSelection + ':' + subSelection;
      var heardAboutResponse =
        mainSelection && subSelection ? concatMainSubSelections : 'skipped';
      var data = {heardAboutResponse: heardAboutResponse};
      return updateUserAccountDetails(data);
    };

    var completeParentExpectations = function completeParentExpectations() {
      var state = storeService.getState();
      var parentExpectations = state.parentExpectations.parentExpectations;
      var hopesResponse = parentExpectations ? parentExpectations : 'skipped';
      var data = {hopesResponse: hopesResponse};
      return updateUserAccountDetails(data);
    };

    var submitMarketingSurvey = function submitMarketingSurvey() {
      completeMarketingSurvey().then(function() {
        storeService.commit([
          {
            stateAlias: 'marketingSurvey',
            mutationId: 'resetState',
            payload: {}
          }
        ]);
        goToNextStep();
      });
    };

    var efficacySurveySubmit = function(payload) {
      riqApiService
        .get('submitSurvey', {response: [payload.form]})
        .then(goToNextStep)
        .catch(goToNextStep);
    };

    var submitParentExpectations = function submitParentExpectations() {
      completeParentExpectations().then(function() {
        storeService.commit([
          {
            stateAlias: 'parentExpectations',
            mutationId: 'resetState',
            payload: {}
          }
        ]);
        goToNextStep();
      });
    };

    // last step
    var completeUserOnboarding = function completeUserOnboarding() {
      var state = storeService.getState();
      var userUuid = state.user.userUuid;
      var ftue = 1;
      var data = {
        userUuid: userUuid,
        userDetails: {
          ftue: ftue
        }
      };

      if (state.user.$role === 'TEACHER') {
        $state.go('manage_students_en');
      } else {
        return riqUserModelService
          .updateUserAccount(data)
          .then(function() {
            storeService.commit([
              {
                stateAlias: 'user',
                mutationId: 'update',
                payload: {
                  ftue: ftue
                }
              }
            ]);

            $state.go('library_en');
          })
          .catch(function(error) {
            // TODO: Add error handling
            console.error(error);
            storeService.commit([
              {
                stateAlias: 'riqToastrs',
                mutationId: 'show',
                payload: 'applicationError'
              }
            ]);
          });
      }
    };

    return {
      goToNextStep: goToNextStep,
      completeUserOnboarding: completeUserOnboarding,
      completeMarketingSurvey: completeMarketingSurvey,
      selectProfile: selectProfile,
      submitMarketingSurvey: submitMarketingSurvey,
      submitParentExpectations: submitParentExpectations,
      efficacySurveySubmit
    };
  };
  return vmService;
});
